export default __webpack_public_path__ + "static/media/logo_nightjet.0871834d.svg";